import { useQuery, QueryResult, QueryHookOptions } from '@apollo/client';
import { useRouter } from 'next/router';
// Hooks
import { useRedirectOnError } from 'hooks';
// Api
import { GET_STREAM } from 'api/streams/queries';
// Types
import { GetStream, GetStreamVariables } from 'api/streams/types/GetStream';

type BasicQueryOptions = Omit<
  QueryHookOptions<GetStream, GetStreamVariables>,
  'query' | 'variables' | 'onCompleted'
>;

type UseGetAthleteMerchProductsOptions = {
  options?: BasicQueryOptions;
  variables?: GetStreamVariables;
  skip?: boolean;
  onCompleted?: () => void;
};

export const useGetStreamBySlug = (
  options?: UseGetAthleteMerchProductsOptions
): QueryResult<GetStream, GetStreamVariables> => {
  const router = useRouter();
  const { streamSlug, athleteSlug } = router.query;
  // Extract only the slug part before any query parameters
  const cleanStreamSlug = (streamSlug as string)?.split('?')[0];

  const data = useQuery<GetStream, GetStreamVariables>(GET_STREAM, {
    variables: {
      ...options?.variables,
      input: {
        slug: cleanStreamSlug,
        storeSlug: athleteSlug as string,
      },
    },
    skip: !cleanStreamSlug || options?.skip,
    ...options?.options,
    onCompleted: options?.onCompleted,
  });

  useRedirectOnError({
    error: data.error,
    skipTokenError: true,
    redirectTo: `/${athleteSlug}/streams`,
  });

  return data;
};
